export default __webpack_public_path__ + "static/media/guard.3356d351.jpg";